"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationListFiltersSidebar = exports.statusFiltersList = exports.typeFiltersList = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const useNotificationListFilters_1 = require("../hooks/useNotificationListFilters");
const useNotificationListState_1 = require("../hooks/useNotificationListState");
const translations_1 = require("../types/translations");
const NotificationListFilterCheckboxList_1 = require("./NotificationListFilterCheckboxList");
const NotificationListFiltersDurationSection_1 = require("./NotificationListFiltersDurationSection");
exports.testIds = {
    closeBtn: 'notification_list-filters-side_panel-close_btn',
    applyBtn: 'notification_list-filters-side_panel-apply_btn',
    resetBtn: 'notification_list-filters-side_panel-reset_btn',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    header: {
        padding: theme.spacing(2),
        position: 'sticky',
        top: 0,
        background: theme.palette.common.white,
        zIndex: 9,
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    paper: {
        background: theme.palette.background.paper,
        width: 354,
    },
    closeBtn: {
        padding: theme.spacing(1.25),
    },
    category: {
        padding: theme.spacing(1.5, 0, 0),
    },
    footer: {
        padding: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.divider}`,
        background: theme.palette.common.white,
        position: 'sticky',
        bottom: 0,
        zIndex: 9,
    },
}));
exports.typeFiltersList = [
    notification_center_models_1.NotificationType.Deviation,
    notification_center_models_1.NotificationType.DeviationRisk,
    notification_center_models_1.NotificationType.Message,
    notification_center_models_1.NotificationType.Update,
];
exports.statusFiltersList = [
    notification_center_models_1.UserNotificationStatus.New,
    notification_center_models_1.UserNotificationStatus.UnRead,
    notification_center_models_1.UserNotificationStatus.Read,
];
const NotificationListFiltersSidebar = ({ open, onClose }) => {
    const notificationListState = (0, useNotificationListState_1.useNotificationListState)();
    const { typeFilter, statusFilter, durationFilter, startDateFilter, endDateFilter, setTypeFilter, setStatusFilter, setDurationFilter, setStartDateFilter, setEndDateFilter, } = (0, useNotificationListFilters_1.useNotificationListFilters)();
    (0, react_1.useEffect)(() => {
        setTypeFilter(notificationListState.typeFilter);
    }, [notificationListState.typeFilter]);
    (0, react_1.useEffect)(() => {
        setStatusFilter(notificationListState.statusFilter);
    }, [notificationListState.statusFilter]);
    (0, react_1.useEffect)(() => {
        setDurationFilter(notificationListState.durationFilter);
    }, [notificationListState.durationFilter]);
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const resetFilters = () => {
        setTypeFilter([]);
        setStatusFilter([]);
        setDurationFilter(null);
        setStartDateFilter(null);
        setEndDateFilter(null);
    };
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Sidebar, { open: open, classes: { paper: classes.paper }, anchor: "right", variant: "temporary", children: [(0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, alignItems: "center", justifyContent: "space-between", className: classes.header, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "h6", className: classes.category, children: translate(translations_1.notificationListFilterTranslations.title) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.IconButton, { "data-testid": exports.testIds.closeBtn, color: "default", className: classes.closeBtn, onClick: onClose, "data-tracking-id": "notification_list-filters-side_panel-close_btn", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.CloseIcon, {}) })] }), (0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { px: 2, pt: 1, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { color: "textSecondary", variant: "body2", className: classes.category, children: translate(translations_1.notificationListFilterTranslations.durationTitle) }), (0, jsx_runtime_1.jsx)(NotificationListFiltersDurationSection_1.NotificationListFiltersDurationSection, { durationFilter: durationFilter, setDurationFilter: setDurationFilter, startDateFilter: startDateFilter, setStartDateFilter: setStartDateFilter, endDateFilter: endDateFilter, setEndDateFilter: setEndDateFilter }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { color: "textSecondary", variant: "body2", className: classes.category, children: translate(translations_1.notificationListFilterTranslations.statusTitle) }), (0, jsx_runtime_1.jsx)(NotificationListFilterCheckboxList_1.NotificationListFilterCheckboxList, { list: exports.statusFiltersList, state: statusFilter, setState: (statusList) => setStatusFilter(statusList), identifier: "status" }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { color: "textSecondary", variant: "body2", className: classes.category, children: translate(translations_1.notificationListFilterTranslations.typeTitle) }), (0, jsx_runtime_1.jsx)(NotificationListFilterCheckboxList_1.NotificationListFilterCheckboxList, { list: exports.typeFiltersList, state: typeFilter, setState: (typeList) => setTypeFilter(typeList), identifier: "type" })] }), (0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, className: classes.footer, justifyContent: "space-between", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { onClick: resetFilters, "data-testid": exports.testIds.resetBtn, "data-tracking-id": "notification_list-filters-reset_filter_button", children: translate(translations_1.notificationListFilterTranslations.resetButton) }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { variant: "contained", "data-testid": exports.testIds.applyBtn, "data-tracking-id": "notification_list-filters-apply_filter_button", onClick: () => {
                                notificationListState.applyFilters({
                                    type: typeFilter,
                                    status: statusFilter,
                                    ...(durationFilter ? { duration: durationFilter } : {}),
                                    ...(startDateFilter ? { startDate: startDateFilter } : {}),
                                    ...(endDateFilter ? { endDate: endDateFilter } : {}),
                                });
                                onClose();
                            }, children: translate(translations_1.notificationListFilterTranslations.applyButton) }) })] })] }));
};
exports.NotificationListFiltersSidebar = NotificationListFiltersSidebar;
//# sourceMappingURL=NotificationListFiltersSidebar.js.map